import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function StepLabel(theme: Theme) {
    return {
        MuiStepLabel: {
            styleOverrides: {
                root: {
                    '& .MuiStepLabel-iconContainer': {
                        paddingRight: 0,
                    },
                },
                label: {
                    '&.MuiStepLabel-alternativeLabel': {
                        marginTop: 2,
                    },
                },
            },
        },
    };
}
